import type { UsageData } from "../lib/api.js";

/** En-tête de quotas et décompte mensuel (cahier des charges §10), en haut des paramètres. */
function fmtBytes(b: number): string {
  if (b >= 1e9) return (b / 1e9).toFixed(2) + " Go";
  return (b / 1e6).toFixed(1) + " Mo";
}
function level(ratio: number): string {
  if (ratio >= 1) return "over";
  if (ratio >= 0.8) return "warn";
  return "";
}

export function UsageHeader({ usage }: { usage: UsageData | null }) {
  if (!usage) return null;
  const c = usage.current;
  const minRatio = c.quotaMinutes ? c.transcribedMinutes / c.quotaMinutes : 0;
  const volRatio = c.quotaAudioBytes ? c.audioBytes / c.quotaAudioBytes : 0;
  return (
    <div className="usage">
      <div className="gauge">
        <div className="gauge-top">
          <span className="gauge-label">Transcription (minutes)</span>
          <span className="gauge-val">{c.transcribedMinutes} / {c.quotaMinutes} min</span>
        </div>
        <div className="gauge-bar">
          <div className={"gauge-fill " + level(minRatio)} style={{ width: Math.min(100, minRatio * 100) + "%" }} />
        </div>
      </div>
      <div className="gauge">
        <div className="gauge-top">
          <span className="gauge-label">Volume audio</span>
          <span className="gauge-val">{fmtBytes(c.audioBytes)} / {fmtBytes(c.quotaAudioBytes)}</span>
        </div>
        <div className="gauge-bar">
          <div className={"gauge-fill " + level(volRatio)} style={{ width: Math.min(100, volRatio * 100) + "%" }} />
        </div>
      </div>
      <div className="usage-count">
        Ce mois : <strong>{c.transcribedMinutes} min</strong> transcrites · <strong>{c.summariesCount}</strong> résumé{c.summariesCount > 1 ? "s" : ""}
      </div>
      {usage.previousMonths.length > 0 && (
        <div className="usage-months">
          {usage.previousMonths.map((m) => (
            <div key={`${m.year}-${m.month}`} className="usage-month">
              <span>{String(m.month).padStart(2, "0")}/{m.year}</span>
              <span>{m.transcribedMinutes} min · {m.summariesCount} résumé{m.summariesCount > 1 ? "s" : ""}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
